module.exports = __webpack_public_path__ + "static/footer_print-837c21d59e6d5d6d768a01e32c0f9d39.png";